import type { IconData } from '@stacksjs/iconify-core'

export const co4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#ffe800\" d=\"M0 0h640v480H0z\"/><path fill=\"#00148e\" d=\"M0 240h640v240H0z\"/><path fill=\"#da0010\" d=\"M0 360h640v120H0z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default co4x3
